// import roundQuarter from './roundQuarter';

export let formatRoomSize = (roomSize) => {
  let widthFeet = Math.round(roomSize.widthInches);
  let heightFeet = Math.round(roomSize.heightInches);
  return `${heightFeet}" × ${widthFeet}"`;
};
